import React, { useState, useMemo } from "react";
import Avatar from "../../components/common/Avatar";
import { NotFound } from "../../components/common/NotFound";
import PaginationComponent from "../common/PaginationComponent";
import SkeletonEnquiryListing from "../common/skeletonEnquiryListing";
import Status from "../../components/common/Status";

function EnquiryDataGrid(props) {
  const {
    filteredResults,
    handleEdit,
    handleDelete,
    handleView,
    loading,
    menuRights,
    moduleName,
  } = props;

  const [count, setCount] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = count;

  const currentTableData = useMemo(() => {
    if (filteredResults?.length <= pageSize) setCurrentPage(1);
    else if (currentPage > Math.ceil(filteredResults?.length / pageSize)) {
      setCurrentPage(1);
    }

    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return filteredResults?.slice(firstPageIndex, lastPageIndex) || [];
  }, [currentPage, filteredResults, count]);

  return (
    <>
      <div className="row enquiry-table-row mb-4rem">
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          {loading === true ? (
            <>
                <SkeletonEnquiryListing rows={15} />
            </>
          ) : currentTableData.length > 0 ? (
            <div className="card enquiry-list-card">
              <div className="card-body">
                <div className="table-responsive enquiry-table-responsive">
                  <table className="table table-borderless table-list enquiry-table-list">
                    <thead>
                      <tr>
                        <th><div>PROJECT</div></th>
                        <th><div>ENQUIRY REF</div></th>
                        <th><div>ENQUIRY DATE</div></th>
                        <th><div>CUSTOMER NAME</div></th>
                        <th><div>DISTRIBUTOR</div></th>
                        <th><div>ASSIGNED TO</div></th>
                        <th><div>COUNTRY</div></th>
                        <th><div>ENQUIRY TYPE</div></th>
                        <th><div>ACTIONS</div></th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentTableData?.map((items, index) => (
                        <tr key={items?.id || index}>
                          <td
                            onClick={menuRights?.canView === true ? () => handleView(items) : undefined}
                            className={menuRights?.canView === true ? "clickable-cell" : ""}
                          >
                            <div className="project-cell">
                              <Avatar preName={items?.projectName} />
                              <h4 title={items?.projectName}>{items?.projectName || "-"}</h4>
                            </div>
                          </td>
                          <td><h5 title={items?.inquiryRef}>{items?.inquiryRef || "-"}</h5></td>
                          <td><h5>{items?.inqDate || "-"}</h5></td>
                          <td><h5 title={items?.customerName}>{items?.customerName || "-"}</h5></td>
                          <td><h5 title={items?.distributorName}>{items?.distributorName || "-"}</h5></td>
                          <td><h5 title={items?.allocatedToName}>{items?.allocatedToName || "-"}</h5></td>
                          <td><h5 title={items?.countryName}>{items?.countryName || "-"}</h5></td>
                          <td>
                            <button
                              type="button"
                              className={items?.enquiryType === "Tender" ? "btn tender-btn" : "btn in-hand-btn"}
                            >
                              <span className={items?.enquiryType === "Tender" ? "tender" : "in-hand"}>
                                <Status />
                              </span>
                              {items?.enquiryType || "-"}
                            </button>
                          </td>
                          <td>
                    {(menuRights?.canEdit === true || menuRights?.canDelete === true) &&
                        <div class="dropdown dropleft text-center action-menu">
                          <i
                            class="fas fa-ellipsis-v"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="false"
                            aria-expanded="false"
                          ></i>
                          <div
                            class="dropdown-menu p-0"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <ul>
                              {menuRights?.canEdit === true && <li>
                                <span
                                  onClick={() => {
                                    handleEdit(items);
                                  }}
                                >
                                  <i class="far fa-edit"></i> Edit
                                </span>
                              </li>}
                              {menuRights?.canDelete === true && <li>
                                <span
                                  onClick={() => {
                                    handleDelete(items);
                                  }}
                                >
                                  <i class="far fa-trash-alt mr-1"></i> Delete
                                </span>
                              </li>}
                            </ul>
                          </div>
                        </div>}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <NotFound />
          )}
        </div>
      </div>
      {currentTableData.length > 0 && (
        <PaginationComponent
          count={count}
          setCount={setCount}
          pageSize={pageSize}
          currentPage={currentPage}
          filteredResults={filteredResults}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  );
}

export default EnquiryDataGrid;
